import { render } from "./BaseWrapper.vue?vue&type=template&id=7ba98700&scoped=true"
import script from "./BaseWrapper.vue?vue&type=script&lang=js"
export * from "./BaseWrapper.vue?vue&type=script&lang=js"

import "./BaseWrapper.vue?vue&type=style&index=0&id=7ba98700&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba98700"]])

export default __exports__